<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="top wrap clear">
            <h2 class="bold mb-10 float-left">불참사유서 제출</h2>
            <span class="font-14 float-right cur-pointer mt-10" @click="goResonList()">내 불참사유서 <img src="../assets/img/arrow-right-gray.png"/></span>
        </div>

        <div class="reason-wrap">
            <div class="clear reason-box">
                <div class="float-left w-25per txt-left pl-20 reason-box-title">이름<span class="col-red">*</span></div>
                <div class="float-left w-75per pr-20">
                    <input type="text" placeholder="이름을 입력해 주세요." class="w-100per" v-model="info.kname" />
                </div>
            </div>

            <div class="clear reason-box">
                <div class="float-left w-25per  txt-left pl-20 reason-box-title">부서</div>
                <div class="float-left w-75per pr-20">
                    <input type="text" placeholder="부서명을 입력해 주세요." class="w-100per" v-model="dept" />
                </div>
            </div>

            <div class="clear reason-box">
                <div class="float-left w-25per  txt-left pl-20 reason-box-title">사번</div>
                <div class="float-left w-75per pr-20">
                    <input type="text" placeholder="사번을 입력해 주세요." class="w-100per" v-model="c_id" />
                </div>
            </div>

            <div class="clear reason-box">
                <div class="float-left w-25per  txt-left pl-20 reason-box-title">불참일자<span class="col-red">*</span></div>
                <div class="float-left w-75per pr-20">
                    <input class="date" type="date" v-model="absence_date" id="absence_date">
                </div>
            </div>

            <div class="clear reason-box">
                <div class="float-left w-25per  txt-left pl-20 reason-box-title">사유<span class="col-red">*</span></div>
                <div class="float-left w-75per pr-20">
                    <label class="mr-10"><input type="radio" name="reason" v-model="reason" value="BUTR" />&nbsp;출장</label>
                    <label class="mr-10"><input type="radio" name="reason" v-model="reason" value="VACA" />&nbsp;휴가</label>
                    <label class="mr-10"><input type="radio" name="reason" v-model="reason" value="MEET" />&nbsp;회의</label>
                    <label class="mr-10"><input type="radio" name="reason" v-model="reason" value="ETC" />&nbsp;기타</label>
                </div>
                <div class="float-left pl-20 ml-70" v-if="reason=='ETC'">
                    <input type="text" name="reason_detail" id="reason_detail" class="input" placeholder="기타 사유를 써주세요" v-model="reason_detail">
                </div>
            </div>

            <div class="clear reason-box">
                <textarea id="contents" class="textarea" v-model="contents"></textarea>
            </div>

            <div class="clear reason-box">
                <div class="float-left w-25per  txt-left pl-20 reason-box-title">첨부파일1
                    <span class="col-red" v-if="info.is_statement=='Y' && info.is_auto_bz_file=='Y'">*</span>
                </div>
                <div class="float-left w-75per pr-20 pl-10">
                    <input type="file" @change="reasonFile($event)" id="reason_file" name="reason_file" accept=".jpg, .png, .word, .hwp, .pdf, .ppt, .pptx"/>
                    &nbsp;<span class="col-red">예시 : 공문, 출장내역서 등</span>
                </div>
            </div>

            <div class="clear reason-box">
                <div class="float-left w-25per  txt-left pl-20 reason-box-title">첨부파일2</div>
                <div class="float-left w-75per pr-20 pl-10">
                    <input type="file" @change="reasonFile1($event)" id="reason_file1" name="reason_file1" accept=".jpg, .png, .word, .hwp, .pdf, .ppt, .pptx"/>
                </div>
            </div>
        </div>
        <div class="pl-20 pr-20 pt-20 wrap">
            <button class="btn-base-white float-left" @click="cancel()">취소</button>
            <button class="btn-base float-right" @click="doSubmit()">제출하기</button>
        </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'ResonAdd',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        classid: "",
        kname: "",
        dept: "",
        c_id: "",
        reason: "",
        reason_detail: "",
        reason_file: "",
        reason_file1: "",
        contents: "상기와 같은 사유로 교육을 불참하고자 하오니 승인하여 주시기 바랍니다.",
        info: {},
        attenddate_list: [],
        datalist: [],
        total: 0,
        absence_date: ""
    }),
    mounted() {
        //    this.doc_del_rendar();
        this.classid = this.$route.query.classid;
        this.initPage();
    },
    methods: {
        created() {
            if(location.hostname == "stagest.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else if(location.hostname == "st.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.hostname == "student.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.hostname == "m.carrotenglish.net"){
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }else if(location.href.includes("how")){
                if(location.href.includes("stage")){
                    this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                }else{
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
            this.$store.commit("loginCheck");
        },
        cancel:function(){
            var me = this;
            location.href="/class?classid="+me.classid;
        },
        goResonList:function(){
            var me = this;
            location.href="/reasonlist?classid="+me.classid;
        },
        reasonFile1: function (event) {
            var fileext = event.target.files[0].name.slice(event.target.files[0].name.indexOf(".")+1).toLowerCase();
            // console.log(fileext);
            var mexSize = 2 * 1024 * 1024
            if(event.target.files[0].size > mexSize){
                alert("첨부파일 사이즈는 2MB 이내로 등록 가능합니다.");
                return false;
            }else{
                if(fileext == 'jpg' || fileext == 'png' || fileext=='word' || fileext == 'hwp' || fileext == 'pdf' || fileext == 'ppt' || fileext == 'pptx'){
                    this.reasonFile1 = event.target.files[0].name;
                }else{
                    alert("파일첨부는 jpg, png, word, hwp, pdf, ppt 만 가능합니다.");
                    return false;
                }
            }
        },
        reasonFile: function (event) {
            var fileext = event.target.files[0].name.slice(event.target.files[0].name.indexOf(".")+1).toLowerCase();
            // console.log(fileext);
            var mexSize = 2 * 1024 * 1024
            if(event.target.files[0].size > mexSize){
                alert("첨부파일 사이즈는 2MB 이내로 등록 가능합니다.");
                return false;
            }else{
                if(fileext == 'jpg' || fileext == 'png' || fileext=='word' || fileext == 'hwp' || fileext == 'pdf' || fileext == 'ppt' || fileext == 'pptx'){
                    this.reasonFile1 = event.target.files[0].name;
                }else{
                    alert("파일첨부는 jpg, png, word, hwp, pdf, ppt 만 가능합니다.");
                    return false;
                }
            }
            // console.log(this.reasonFile);
        },
        initPage: function () {
            console.log("init page");
            var me = this;
            var params = {
                uidx: localStorage.getItem("uidx")
            }
            this.axios.get(this.$store.state.host + '/rest/mobile/classStatementInfo_new/' + me.classid, {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.info = res.data;
                    me.attenddate_list = res.data.list;
                    me.info.kname = localStorage.getItem("kname");
                } else {
                    alert(res.data.err_msg);
                }
                me.is_loader = false;
            });
        },
        doSubmit: function () {
            console.log("insert 불참사유서");

            if (this.absence_date) this.absence_date = this.getDate(this.absence_date);
            var params = {
                classid: this.classid,
                absence_date: this.absence_date,
                kname: this.info.kname,
                dept: this.dept,
                c_id: this.c_id,
                reason: this.reason,
                reason_detail: this.reason_detail,
                reason_file: this.reason_file,
                contents: this.contents,
                tmr: Date.now()
            };

            if (!params.kname) {
                alert('성명을 입력해 주세요.');
                document.getElementById("kname").focus();
                return;
            }
            if (!params.absence_date) {
                alert('불참 날짜를 선택해 주세요.');
                document.getElementById("absence_date").focus();
                return;
            }
            if (!params.reason) {
                alert('사유를 선택해 주세요.');
                document.getElementById("reason1").focus();
                return;
            }
            if ('ETC' == params.reason && '' == params.reason_detail) {
                alert('기타 사유를 입력해 주세요.');
                document.getElementById("reason_detail").focus();
                return;
            }
            if(this.info.is_statement=='Y' && this.info.is_auto_bz_file=='Y' && !document.getElementById("reason_file").files[0]){
                alert("첨부파일1을 등록해주세요.");
                return;
            }

            if (confirm("입력하신 내용으로 불참사유서를 제출 하시겠습니까?") == true) {
                var me = this;
                var formData = new FormData();
                formData.append("classid", params.classid);
                formData.append("kname", params.kname);
                formData.append("dept", params.dept);
                formData.append("c_id", params.c_id);
                formData.append("absence_date", params.absence_date);
                formData.append("reason", params.reason);
                formData.append("reason_detail", params.reason_detail);
                formData.append("contents", params.contents);
                formData.append("reason_file", document.getElementById("reason_file").files[0]);
                formData.append("reason_file1", document.getElementById("reason_file1").files[0]);
                formData.append("uidx", localStorage.getItem("uidx"));
                formData.append("tmr", Date.now());
                if (formData.reason_file == "undefined") {
                    return;
                }
                this.axios.post(this.$store.state.host + "/rest/mobile/classStatement_new", formData).then(function (res) {
                    if (res.data.err == 0) {
                        alert("불참 사유서가 제출 되었습니다. \n취소는 이번달 내에 가능합니다.");
                        // me.btn_tab(2);
                        location.href="/reasonlist?classid="+me.classid;
                        me.absence_date = "";
                        me.kname = "";
                        me.dept = "";
                        me.c_id = "";
                        me.reason = "";
                        me.contents = "상기와 같은 사유로 교육을 불참하고자 하오니 승인하여 주시기 바랍니다.";
                    } else {
                        alert(res.data.err_msg);
                    }
                });
            }
        },
        getDate:function (date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
            // return (d).toISOString().slice(0, 10).replace(/-/g, "-");
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    .top {
        padding-right: 20px;
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;
        width: 100%;
        max-width: none;
        h2 {
            padding-bottom: 20px;
        }

        position: relative;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }
    }
    .wrap {
        width: 90%;
        max-width: 700px;
    }

    .reason-wrap {
        width: 90%;
        margin: 0 auto;
        max-width: 700px;
        .reason-box {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            padding-top: 10px;
            padding-bottom: 10px;

            .reason-box-title {
                height: 45px;
                line-height: 45px;
            }

            div {
                height: 45px;
                line-height: 45px;
            }

            input[type="text"],
            input[type="password"] {
                border-radius: 0;
                border-top: none;
                border-right: none;
                border-left: none;
                border-bottom: none;
                font-size: 16px;
                height: 45px;
                padding: 0 10px;
            }

            select {
                border: none;
                height: 45px;
            }

            textarea {
                width: 100%;
                border: none;
                resize: none;
                height: 130px;
                padding-left: 20px;
                font-size: 14px;
                color: #000;
            }
        }
    }
}

.footer {
    position: static;
}
.class{
    width: 1200px;
    margin: 0 auto;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;
        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;
            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }

        .tab {
            &.wrap {
                width: 100%;
            }
        }
        .reason-wrap {
            width: 100%;
        }
        .writing {
            .lecture {
                margin-top: 0px;
                border-top: none;
                border-bottom: 10px solid $border-color;
            }

            table {
                width: 100%;

                th {
                    color: $gray;
                    padding: 8px 10px 0 0;
                    text-align: left;
                    width: 80px;
                }
            }
        }

        // 출결
        .calendar-wrap {
            .calendar-col {
                background: $back-gray;
                padding: 5px 0;
                font-size: 12px;

                &.wrap {
                    width: 100%;
                }

                span {
                    margin-right: 5px;
                }

                .attend {
                    padding-left: 5%;
                }
            }

            .calendar {
                padding: 0px;
            }
        }
        .wrap{
            width: 100%;
        }
    }
}
</style>
